import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import React, { FC, PropsWithChildren } from "react";
export type SkeletonProps = PropsWithChildren<{
  className?: string;
  width?: number | string;
  height?: number | string;
  isLoading: boolean | undefined;
  as?: React.ElementType;
  lines?: number;
}>;
type SkeletonBlockProps = PropsWithChildren<Pick<SkeletonProps, "as" | "className" | "height" | "width">>;
const SkeletonBlock: FC<SkeletonBlockProps> = t0 => {
  const $ = _c(13);
  const {
    children,
    as,
    className,
    width,
    height
  } = t0;
  const Element = as ?? "div";
  let t1;
  if ($[0] !== className) {
    t1 = className?.includes("rounded");
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !t1;
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = clsx(className, "bg-neutral-50 max-w-full animate-pulse", {
      "rounded-xs": t2
    });
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== height || $[6] !== width) {
    t4 = {
      width,
      height
    };
    $[5] = height;
    $[6] = width;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== Element || $[9] !== children || $[10] !== t3 || $[11] !== t4) {
    t5 = <Element className={t3} style={t4}>{children}</Element>;
    $[8] = Element;
    $[9] = children;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
const Skeleton: FC<SkeletonProps> = t0 => {
  const $ = _c(20);
  let children;
  let height;
  let isLoading;
  let props;
  let t1;
  let width;
  if ($[0] !== t0) {
    ({
      children,
      isLoading,
      lines: t1,
      height,
      width,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = height;
    $[3] = isLoading;
    $[4] = props;
    $[5] = t1;
    $[6] = width;
  } else {
    children = $[1];
    height = $[2];
    isLoading = $[3];
    props = $[4];
    t1 = $[5];
    width = $[6];
  }
  const lines = t1 === undefined ? 1 : t1;
  if (isLoading) {
    if (lines > 1) {
      let t2;
      if ($[7] !== lines || $[8] !== props || $[9] !== width) {
        let t3;
        if ($[11] !== props || $[12] !== width) {
          t3 = (_, i) => <div key={i} className="flex max-w-full" style={{
            width
          }}><SkeletonBlock {...props} height="1em" width="100%" /><span className="inline-block w-none overflow-hidden"> </span></div>;
          $[11] = props;
          $[12] = width;
          $[13] = t3;
        } else {
          t3 = $[13];
        }
        t2 = new Array(lines).fill(undefined).map(t3);
        $[7] = lines;
        $[8] = props;
        $[9] = width;
        $[10] = t2;
      } else {
        t2 = $[10];
      }
      return t2;
    }
    let t2;
    if ($[14] !== height || $[15] !== props || $[16] !== width) {
      t2 = <SkeletonBlock {...props} width={width} height={height}> </SkeletonBlock>;
      $[14] = height;
      $[15] = props;
      $[16] = width;
      $[17] = t2;
    } else {
      t2 = $[17];
    }
    return t2;
  }
  let t2;
  if ($[18] !== children) {
    t2 = <>{children}</>;
    $[18] = children;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  return t2;
};
export default Skeleton;